import { bool, oneOf, shape, string, arrayOf } from 'prop-types';

export const singleMission = shape({
  id: string,
  createdAt: string,
  missionName: string,
  user: string,
  labelingType: oneOf(['tagging', 'classifier', 'multilabel']),
  missionChecked: bool,
  hasChecks: bool,
});

export const missions = arrayOf(singleMission);

export default {
  singleMission,
  missions,
};
